import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const getAllUsers = {
  name: 'getAllUsers',
  state: {
    data: [],
    loading: false,
    error: '',
  },
  reducers: {
    getRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        data: [],
      };
    },

    getReceived(state, payload) {
      const usersData = payload.data?.map(item => ({
        id: item.id,
        name: item.name,
        org_id:item.org_id,
        email: item.email,
        role: item.role_id,
      }));
      return {
        ...state,
        data: usersData,
        loading: false,
        error: '',
      };
    },

    getRequestFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async fetchAllUsers(orgId) {
      try {
        const url = `savvy/organization/getAllUsers?org_id=${orgId}`;
        this.getRequested();
        const response = await http.get(url);
        if (response && response.data) {
          this.getReceived({
            data: response.data.data,
          });
        }
      } catch (err) {
        this.getRequestFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default getAllUsers;
